var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { CheckBox } from '../elements';
import cxs from 'cxs/component';
import View from '../elements/View';
import theme from '../Theme';
var SelectTableHeader = /** @class */ (function (_super) {
    __extends(SelectTableHeader, _super);
    function SelectTableHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (name, head, checked) {
            var temp = _this.props.headers;
            var index = temp.findIndex(function (value) {
                var _head = value.head;
                return head === _head;
            });
            if (index >= 0) { // está
                temp[index].selected = checked;
            }
            _this.props.onChangeHeader(temp);
        };
        return _this;
    }
    SelectTableHeader.prototype.render = function () {
        var _this = this;
        var headers = this.props.headers;
        // console.log('render - headers: ', headers)
        if (!headers) {
            return null;
        }
        return (React.createElement(Wrapper, null, headers.map(function (header) {
            var name = header.name, head = header.head;
            return (React.createElement(View, { key: 'view_' + head, style: {
                    display: 'inline-block'
                } },
                React.createElement(WrapperCheckbox, { key: head, label: name, checked: header.selected, onChange: function (checked) { _this.handleChange(name, head, checked); } })));
        })));
    };
    return SelectTableHeader;
}(Component));
export default SelectTableHeader;
var WrapperCheckbox = cxs(CheckBox)({
    fontSize: 'smaller',
});
var Wrapper = cxs('div')({
    border: "".concat(theme.line.small, "px solid ").concat(theme.color.hairline),
    borderRadius: '5px 5px 0 0',
    marginLeft: '10px',
    marginRight: '10px',
});



//////////////////
// WEBPACK FOOTER
// ./src/components/SelectTableHeader.tsx
// module id = 1142
// module chunks = 0